import React from 'react';

import isArchived from 'archive/isArchived';
import SidepanelItem from 'nav/sidepanel/listing/SidepanelItem';
import {ListableItem} from 'search/SearchConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface ReactionSidepanelItemProps {
  isActive: boolean;
  isCompact: boolean;
  item: ListableItem;
  openResult: (item: ListableItem) => void;
  isChild: boolean;
}

export default function ReactionSidepanelItem(props: ReactionSidepanelItemProps): JSX.Element {
  const {isActive, isCompact, item, isChild} = props;
  return (
    <SidepanelItem
      active={isActive}
      faded={isArchived(item)}
      icon={<BenchlingIcon icon="reaction-vessel" />}
      isCompact={isCompact}
      onClick={() => {
        props.openResult(item);
      }}
      parties={[]}
      title={{
        text: item.name,
        node: <span>{item.name}</span>,
      }}
      tooltipText=""
      isExpandable={false}
      isChild={isChild}
    />
  );
}
